export function getQueryStringhash(key) {
  let after = window.location.search;
  if (after.indexOf("?") === -1) return null; //如果url中没有传参直接返回空
  //key存在先通过search取值如果取不到就通过hash来取
  after = after.substring(1) || window.location.hash.split("?")[1];
  if (after) {
    let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
    let r = after.match(reg);
    if (r != null) {
      return decodeURIComponent(r[2]);
    } else {
      return null;
    }
  }
}

// 保留两位小数自动补0
export function returnFloat(num) {
  let numStr = Number(num).toLocaleString("en-US"); // 转成字符串类型  如能确定类型 这步可省去 // 转成字符串类型  如能确定类型 这步可省去
  if (numStr.indexOf(".") !== -1) {
    let newVal = numStr.split(".");
    if (newVal[1].length === 1) {
      newVal = newVal.join(".");
      newVal += "0";
      numStr = newVal;
    }
  } else {
    numStr += ".00";
  }

  return numStr;
}
